import React, { FC, ReactElement } from 'react';
import classNames from 'classnames';

interface TabOption {
  value: string;
  label?: string | ReactElement;
}

type TabsTheme = 'underline' | 'pill' | 'bedrock';

interface TabsProps {
  options: Array<TabOption>;
  value: string;
  onChange: (e: any, value: string) => void;
  disableActiveStyling?: boolean;
  className?: string;
  containerClassName?: string;
  disableHoverEffect?: boolean;
  labelClasses?: string;
  optionClasses?: string;
  theme?: TabsTheme;
}

export const Tabs: FC<TabsProps> = ({
  options = [],
  value,
  onChange,
  theme = 'underline',
  className,
  containerClassName,
  disableHoverEffect,
  labelClasses,
  optionClasses,
}) => {
  const onOptionClick = (e: any, clickedValue: string) => {
    if (value !== clickedValue) {
      onChange(e, clickedValue);
    }
  };

  const getOptionClasses = (optionValue: string) => {
    return classNames(optionClasses ? optionClasses : 'rounded-2xl child:px-sm child:py-xs text-bedrock-p-strong', {
      'bg-bedrock-brand-primary/transparent text-bedrock-brand-secondary': value === optionValue,
      [`${!disableHoverEffect ? 'hover:opacity-80' : ''} text-bedrock-black cursor-pointer`]: value !== optionValue,
    });
  };

  return (
    <div className={`${containerClassName}`}>
      <nav className='flex space-x-2 items-center' aria-label='Tabs'>
        {options.map((option) => (
          <div
            className={getOptionClasses(option.value)}
            onClick={(e) => onOptionClick(e, option.value)}
            key={option.value}
          >
            {option.label}
          </div>
        ))}
      </nav>
    </div>
  );
};
